module.exports = __webpack_public_path__ + "img/jubilee.d6b249f9.jpg";